import { migrationContext } from '../../migrationUsersBranchView.poeditor';

export const migrationRejectedKeys = {
  description: `${migrationContext}-mbMigrationDoNotWantMoveDescription`,
  exitButton: `${migrationContext}-mbMigrationExitButton`,
  mobileDescription: `${migrationContext}-mbMigrationDoNotWantMoveMobileDescription`,
  title: `${migrationContext}-mbMigrationDoNotWantMoveTitle`,
};
